export function escapeRegExp(text) {
  // copy/pasted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
  return text.replace(/[.+^${}()|[\]\\]/g, "\\$&");
}
